








































































































































































































































































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';
import {
  Interest,
  InterestSettingsResource,
} from '@/api/interestSettings';

@Component({
  computed: mapState(['fiId', 'configVersion']),
  components: {
    KCardHeader,
  },
})
export default class InterestSettings extends Vue {
  headerItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: false,
      link: false,
    },
    {
      text: 'Interest Settings',
      disabled: true,
    },
  ];

  @Inject('InterestSettingsResource')
  interestSettingsResource!: InterestSettingsResource;

  fiId!: number;

  interest: Interest | null = null;

  workingInterest: Interest = InterestSettings.createEmptyInterest();;

  loading: boolean = false;

  cancelling: boolean = false;

  saving: boolean = false;

  isDataModified: boolean = false;

  valid: boolean = false;

  static createEmptyInterest() : Interest {
    return {
      coreInterestRateCalculation: '',
      balanceType: '',
      calculationMethod: '',
      compoundingMethod: '',
      roundingMethod: '',
      roundingDecimalPlaces: undefined,
      coreNonProcessingAccrualMethod: null,
      observeLeapYear: undefined,
    };
  }

  @Watch('fiId')
  mounted() {
    this.interest = null;
    this.loading = true;
    this.interestSettingsResource
      .get(this.fiId)
      .then((res: Interest) => {
        this.interest = res;
        this.initializeWorkingInterest();
      })
      .catch((error) => {
        this.showError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  roundingRule() {
    if (String(this.workingInterest.roundingDecimalPlaces) === '') {
      return 'Required';
    }
    if (this.workingInterest.roundingDecimalPlaces! < 2
        || this.workingInterest.roundingDecimalPlaces! > 8) {
      return 'Decimal Places should be between 2 and 8!';
    }
    return true;
  }

  initializeWorkingInterest() {
    this.isDataModified = false;
    if (this.interest) {
      Object.assign(this.workingInterest, this.interest);
    } else {
      this.workingInterest = InterestSettings.createEmptyInterest();
    }
  }

  onModification() {
    if ((this.workingInterest.roundingDecimalPlaces
        && this.workingInterest.roundingDecimalPlaces >= 2
        && this.workingInterest.roundingDecimalPlaces <= 8)
        && (this.workingInterest.coreInterestRateCalculation !== this.interest!.coreInterestRateCalculation
            || this.workingInterest.balanceType !== this.interest!.balanceType
            || this.workingInterest.calculationMethod !== this.interest!.calculationMethod
            || this.workingInterest.compoundingMethod !== this.interest!.compoundingMethod
            || this.workingInterest.roundingMethod !== this.interest!.roundingMethod
            || this.workingInterest.roundingDecimalPlaces !== this.interest!.roundingDecimalPlaces
            || this.workingInterest.coreNonProcessingAccrualMethod !== this.interest!.coreNonProcessingAccrualMethod
            || this.workingInterest.observeLeapYear !== this.interest!.observeLeapYear)) {
      this.isDataModified = true;
    } else {
      this.isDataModified = false;
    }
  }

  isValid() {
    if (this.workingInterest.coreInterestRateCalculation === '') {
      this.setError('Core Interest Rate Calculation is required!');
      return false;
    }
    if (this.workingInterest.balanceType === '') {
      this.setError('Balance Type is required!');
      return false;
    }
    if (this.workingInterest.calculationMethod === '') {
      this.setError('Calculation Method is required!');
      return false;
    }
    if (this.workingInterest.compoundingMethod === '') {
      this.setError('Compounding Method is required!');
      return false;
    }
    if (this.workingInterest.roundingMethod === '') {
      this.setError('Rounding Method is required!');
      return false;
    }
    if (this.workingInterest.coreInterestRateCalculation === 'QUAL_RATE'
        && this.workingInterest.coreNonProcessingAccrualMethod === null) {
      this.setError('Non-Processing Day Accruals is required!');
      return false;
    }
    if (this.workingInterest.observeLeapYear === undefined) {
      this.setError('Observe Leap Year is required!');
      return false;
    }
    return true;
  }

  saveInterestSettings() {
    this.saving = true;

    if (!this.isValid()) {
      this.saving = false;
      return;
    }

    this.interestSettingsResource
      .update(this.fiId, this.workingInterest!)
      .then((result: any) => {
        this.interest = result;
        this.initializeWorkingInterest();

        const al = new Alert('Interest Settings saved successfully.', NoticeClass.SUCCESS);
        al.setTimeout(5000);
        this.$store.dispatch('notices/add', al);
      })
      .finally(() => {
        this.saving = false;
      })
      .catch((error) => {
        this.showError(error);
      });
  }

  setCompundingMethodToMonthly() {
    this.workingInterest.compoundingMethod = 'MONTHLY';
    this.onModification();
  }

  setCoreNonProcessingAccrualMethodToNull() {
    this.workingInterest.coreNonProcessingAccrualMethod = null;
    this.onModification();
  }

  setCoreNonProcessingAccrualMethodToExistingValue() {
    this.workingInterest.coreNonProcessingAccrualMethod = this.interest!.coreNonProcessingAccrualMethod;
    this.onModification();
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
